module.exports = __webpack_public_path__ + "static/media/hero-10.f2ff0451.jpg";